import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from "./home/home.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { AuthGuard } from '../common/guards/auth.guard';
import { UserRole, UserRoleFactory } from '../common/models/user/user-role.enum';
import { ContactUsComponent } from './home-pages/contact-us/contact-us.component';
import { HomeCalculatorComponent } from './home-pages/home-calculator/home-calculator.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  {
    path: 'home-calculator',
    component: HomeCalculatorComponent,
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'register',
    loadChildren: () => import('./register/register.module').then(m => m.RegisterModule),
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule),
  },
  {
    path: 'admin',
    loadChildren: () => import('./admin-pages/admin-pages.module').then(m => m.AdminPagesModule),
    canActivate: [AuthGuard],
    data: {
      roles: [UserRole.ROLE_ADMIN],
    },
  },
  {
    path: 'customer',
    loadChildren: () => import('./customer/customer.module').then(m => m.CustomerModule),
    canActivate: [AuthGuard],
    data: {
      roles: [
        UserRole.ROLE_PERSONAL,
        UserRole.ROLE_BUSINESS,
        UserRole.ROLE_BUSINESS_EXP,
        UserRole.ROLE_BUSINESS_PLUS_EXP,
        UserRole.ROLE_BUSINESS_PLUS,
      ],
    },
  },
  {
    path: 'pricing',
    loadChildren: () => import('./pricing/pricing.module').then(m => m.PricingModule),
  },
  {
    path: 'payment',
    loadChildren: () => import('./payment/payment.module').then(m => m.PaymentModule),
    canActivate: [AuthGuard],
    data: {
      roles: UserRoleFactory.allRoles(),
    },
  },
  {
    path: 'user',
    loadChildren: () => import('./user/user.module').then(m => m.UserModule),
  },
  {
    path: 'otp-frame',
    loadChildren: () => import('./calculator-frame/calculator-frame.module').then(m => m.CalculatorFrameModule),
  },
  {
    path: 'calculator-frame-ephzhb',
    loadChildren: () => import('./calculator-frame-ephzhb/calculator-frame-ephzhb.module').then(m => m.CalculatorFrameEphzhbModule),
  },
  { path: 'contact-us', component: ContactUsComponent },
  { path: '**', redirectTo: 'page-not-found' },  // Wildcard route for a 404 page
  { path: 'page-not-found', component: PageNotFoundComponent },  // Wildcard route for a 404 page
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
